<template>
  <generic-modal
    :value="value"
    :is-disabled="isDisabled"
    :is-loading="isLoading"
    title="Create Page Type"
    persistent
    confirm-text="Create"
    hide-louis
    @modal-confirm="onCreateConfirm"
    @modal-cancel="onCreateCancel"
  >
    <v-form ref="form">
      <text-input v-model="formData.name" :rules="rules.name" required label="Name" outlined />
      <autocomplete-input
        v-model="formData.page_type_group_id"
        :items="pageTypeGroups"
        class="input-styles"
        label="Page Type Group"
        hide-details
        outlined
      />
    </v-form>
  </generic-modal>
</template>

<script>
import { kebabCase } from 'lodash-es'
import { pageTypes } from '@/services/offers'
import GenericModal from '@/components/modals/generic-modal'
import TextInput from '@/components/forms/text-input'
import AutocompleteInput from '@/components/forms/autocomplete-input'

export default {
  components: { GenericModal, TextInput, AutocompleteInput },
  props: {
    pageTypeGroups: {
      type: Array,
      required: true,
    },
    value: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      rules: {
        name: [v => !!v || 'Name is required', v => (!!v && v.length > 0) || 'Name must be greater than 0'],
        page_type_group_id: [
          v => !!v || 'Page Type Group is required',
          v => (!!v && v.length > 0) || 'Page Type Group must be greater than 0',
        ],
      },
      formData: {
        name: null,
        core_entities: [],
        has_hub: false,
        is_ready: false,
        page_type_group_id: null,
        primary_offer_type: null,
        schema: { layout: 'main', sections: { main: [] } },
        template_options: [],
      },
    }
  },
  computed: {
    isDisabled() {
      if (this.isLoading) return true
      const { name, page_type_group_id } = this.formData
      return !name || !page_type_group_id
    },
  },
  methods: {
    async onCreateConfirm() {
      if (!this.$refs.form.validate()) return
      try {
        this.isLoading = true
        const { id } = await pageTypes.create({ ...this.formData, name: kebabCase(this.formData.name) })
        this.$notify({ type: 'success', text: 'Successfully created a page type' })
        this.$router.push({ name: 'page-types.manage', params: { id } })
      } catch (e) {
        this.isLoading = false
        console.log(e)
        this.$notify({ type: 'error', text: 'Unable to create page type.', data: { error: e }, duration: -1 })
      }
    },
    onCreateCancel() {
      this.$emit('cancel')
    },
  },
}
</script>
